import { AnimatePresence, motion } from 'framer-motion'
import CompareArrowsRoundedIcon from '@mui/icons-material/CompareArrowsRounded'
import { IconButton } from '../Common/IconButton'
import type { ReactNode } from 'react'
import type { ManageWorkspaceMode } from './ManageWorkspaceHeaderControls'

type Props = {
  mode: ManageWorkspaceMode
  leftControls?: ReactNode
  boardCrumb: ReactNode
  reviewHeading: ReactNode
  boardActions?: ReactNode
  onSwitchMode: () => void
}

export const ManageTopChrome = ({
  mode,
  leftControls,
  boardCrumb,
  reviewHeading,
  boardActions,
  onSwitchMode,
}: Props) => (
  <div className="manageTopChrome" role="group" aria-label="Manage top bar">
    {leftControls && <div className="manageTopChromeLeft">{leftControls}</div>}
    <div className="manageTopChromeSwap">
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={mode}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.15 }}
          className="manageTopChromeSwapInner"
          data-testid={`manage-top-chrome-${mode}`}
        >
          {mode === 'board' ? boardCrumb : reviewHeading}
        </motion.div>
      </AnimatePresence>
    </div>
    {boardActions && <div className="manageTopChromeActions">{boardActions}</div>}
    <IconButton
      size="sm"
      variant="tertiary"
      style={{ flexShrink: 0 }}
      onClick={onSwitchMode}
      title={mode === 'review' ? 'Switch to Board view' : 'Switch to Review view'}
      label={mode === 'review' ? 'Switch to Board view' : 'Switch to Review view'}
      icon={<CompareArrowsRoundedIcon fontSize="inherit" />}
    />
  </div>
)

export default ManageTopChrome
